import { map } from 'rxjs';
import {
	ICoreRoutes,
	IPageMetadata,
	ISharedData,
	ITypeRoute,
	ITypeRouteAction,
	RouteInitializer
} from '../../pages/type-routes/type-route.models.js';
import { AppSetupFormComponent } from 'src/app/modules/app-setup/app-setup-form.component.js';
import { AppSetupDb } from 'lib/cosmos/app-setup/appSetupDb.js';

export interface IAdminAppSetupRoutes extends ICoreRoutes {
	appSetup: ITypeRoute<
		AppSetupDb.IAppSetupItem,
		{
			form: ITypeRouteAction<undefined>;
		}
	>;
}

export const adminAppSetupRoutes: RouteInitializer<IAdminAppSetupRoutes> = {
	appSetup: {
		mainPath: 'admin',
		uniqueId: 'appSetup',
		parentRoutes: (context) => [],
		loadSharedData: (context) => {
			return context.dependencies.httpService
				.get<AppSetupDb.IAppSetupItem>((builder) => {
					return builder.withCustomApiRoute('appSetup', 'getAppSetup').build();
				})
				.pipe(
					map((response) => {
						const sharedData: ISharedData<AppSetupDb.IAppSetupItem> = {
							linkedItems: response.linkedItems,
							data: response.data
						};

						return sharedData;
					})
				);
		},
		menuItems: (context) => [],
		children: {
			form: {
				uniqueId: `appSetupForm`,
				component: AppSetupFormComponent,
				getMetadata: (data) => {
					const metadata: IPageMetadata = {
						title: `App setup`
					};
					return metadata;
				}
			}
		}
	}
};
